export default __webpack_public_path__ + "static/TURO_nagranie_ekranu-4ee985e9b3ee8ef4cd9ea4de041f9872.mp4";